import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Col,
  Row,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import SettingsEditButtons from '../../../EditButtons';
import SettingsItemsWrapper from '../../../Item/ItemsWrapper';
import MetadataMapping from './MetadataMapping';
import TrialNotice from '../../../../../TrialNotice';
import UpgradePlanButton from '../../../../../UpgradePlanButton';

const SettingsMetadataContent = (props) => {
  const {
    saving, handleSave, unsaved,
  } = props;

  const intl = useIntl();

  return (
    <>
      <div className="settings-inner-content">
        <Row>
          <Col>
            <h3>
              {intl.formatMessage({ defaultMessage: 'Sync metadata' })}
              <UpgradePlanButton feature="download-file-with-metadata" />
            </h3>
          </Col>
        </Row>
        <TrialNotice feature="download-file-with-metadata" className="pl-0" />
        <SettingsItemsWrapper
          {...props}
        />
        <MetadataMapping
          {...props}
        />
      </div>
      <SettingsEditButtons
        saving={saving}
        handleSave={handleSave}
        unsaved={unsaved}
      />
    </>
  );
};

const mapStateToProps = state => ({
  clientSettings: state.App.settings,
});

SettingsMetadataContent.propTypes = {
  saving: PropTypes.bool.isRequired,
  handleSettingChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  unsaved: PropTypes.bool.isRequired,
  settings: PropTypes.object.isRequired,
  clientSettings: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(SettingsMetadataContent);
